import React, { useState, useMemo } from 'react';
import { useIntl } from 'react-intl';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { FlexipassDoor, RemotelockPin, Settings } from '../../../models';
import { DigitalKeysBottomSheet } from './DigitalKeysBottomSheet';

import DigitalKeysSvg from '../../../public/images/digital-keys.svg';

import styles from './DigitalKeysAvailable.module.scss';

const PREVIEW_DOOR_COUNT = 3;

interface DigitalKeysAvailableProps {
  title: string;
  settings?: Settings;
  onDoorOpen?: (doorId: number) => Promise<any>;
  preview?: boolean;
  type: 'flexipass' | 'remotelock';
  items?: FlexipassDoor[] | RemotelockPin[];
}

export const DigitalKeysAvailable = ({
  title,
  type,
  settings,
  items = [],
  onDoorOpen,
  preview,
}: DigitalKeysAvailableProps) => {
  const doors = items || [];
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);

  const doorCount = preview ? PREVIEW_DOOR_COUNT : (doors.length ?? 0);
  const layoutStyles = useMemo(() => {
    if (settings) {
      return {
        borderColor: settings.whistle_guest_primary_button_color,
        color: settings.whistle_guest_primary_button_color,
      };
    }
    return undefined;
  }, [settings]);

  return (
    <>
      <section
        className={styles.section}
        onClick={() => setBottomSheetOpen(true)}
        style={layoutStyles}
      >
        <div className={styles.container}>
          <DigitalKeysSvg />
          <div className={styles.label}>
            <span>{title}</span>
            <span>({doorCount})</span>
          </div>
        </div>
        <ChevronRightIcon />
      </section>

      {!preview && !!items.length && (
        <DigitalKeysBottomSheet
          type={type}
          settings={settings}
          items={items}
          open={bottomSheetOpen}
          onClose={() => setBottomSheetOpen(false)}
          onDoorOpen={onDoorOpen}
        />
      )}
    </>
  );
};
